/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InterpolationVariableEnum {
    TASK_EFFECTIVE_DATE = 'TASK_EFFECTIVE_DATE',
    REPORTER_NAME = 'REPORTER_NAME',
    TODAY = 'TODAY',
}
